import { CONFIG } from "~/config";
import { IMapState } from "~/state/map/interfaces";
import { store } from "~/state/store";
import { watch, watchCoordinates } from "~/state/util";
import { node } from "~/util/dom";

const WORLD_START_POINTER_IN_PIXELS = [4, 4];
const WORLDMAP_SIZE = [122, 84];

export default class MiniWorldMap {
	#container: HTMLDivElement;

	#point: HTMLDivElement;

	#url: string;

	constructor() {
		this.#url = `${CONFIG.apiUrl}/img/web/world-overview.png`;

		this.#build();
		this.#update(store.getState().map);

		const wt = watch(store.getState, "map", watchCoordinates);

		store.subscribe(wt((newMap, oldMap) => {
			if (
				newMap.longitude !== oldMap.longitude
				|| newMap.latitude !== oldMap.latitude
				|| newMap.zoom !== oldMap.zoom
			) {
				this.#update(newMap);
			}
		}));
	}

	get container() {
		return this.#container;
	}

	#build() {
		const container = node("div", { className: "control-mini-world-map print" });
		const img = node("img", { src: this.#url, alt: "", crossOrigin: "anonymous" });
		const point = node("div", { className: "world-point" });

		container.append(img, point);

		this.#point = point;
		this.#container = container;
	}

	#update(mapState: IMapState) {
		const left = ((WORLDMAP_SIZE[0] / 360) * mapState.longitude) + WORLD_START_POINTER_IN_PIXELS[0] + ((WORLDMAP_SIZE[0] / 2) - 6);
		const top = ((WORLDMAP_SIZE[1] / 180) * mapState.latitude * -1) + WORLD_START_POINTER_IN_PIXELS[1] + ((WORLDMAP_SIZE[1] / 2) - 6);

		this.#point.style.left = `${left}px`;
		this.#point.style.top = `${top}px`;
	}
}
